export enum WorkingHoursDataTestId {
  TOGGLE_HOURS_BUTTON = 'toggle-hours--branch-working-hours',
}
